var _indexOf =
/*#__PURE__*/
require("./_indexOf");

function _includes(a, list) {
  return _indexOf(list, a, 0) >= 0;
}

module.exports = _includes;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/src/internal/_includes.js
// module id = 1080
// module chunks = 8